import { taggedTemplateLiteral as _taggedTemplateLiteral, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import propTypes from '../../node_modules/prop-types/index.js';
import React from 'react';
import classnames from '../../node_modules/classnames/index.js';
import { styled, useThemeProps } from '@mui/material';
import { ActionMenuDirection } from './constants.js';
import ActionMenuTrigger from './ActionMenuTrigger.js';
import ActionMenuItem from './ActionMenuItem.js';
import TriggerMenu from './base/TriggerMenu.js';
import { createComponentSlot } from '../../modules/styling/theme.js';

var _templateObject;

var _excluded = ["direction", "triggerComponent", "className"];
var componentRoot = createComponentSlot({
  name: "CinActionMenu",
  slot: "Root"
});

var ActionMenuBase = function ActionMenuBase(_ref) {
  var _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? ActionMenuDirection.Left : _ref$direction,
      _ref$triggerComponent = _ref.triggerComponent,
      triggerComponent = _ref$triggerComponent === void 0 ? ActionMenuTrigger : _ref$triggerComponent,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(TriggerMenu, _extends({}, props, {
    direction: direction,
    triggerComponent: triggerComponent,
    className: classnames(componentRoot.className, className)
  }));
};

ActionMenuBase.propTypes = {
  direction: propTypes.any
};
var ActionMenuRoot = styled(ActionMenuBase, componentRoot.styledOptions)(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
/**
 * A dropdown menu for a list of actions
 */

var ActionMenu = function ActionMenu(props) {
  var rootProps = useThemeProps({
    props: props,
    name: componentRoot.name
  });
  return /*#__PURE__*/React.createElement(ActionMenuRoot, rootProps);
};
/** A single item for a dropdown list of actions */


ActionMenu.Item = ActionMenuItem;
var ActionMenu$1 = ActionMenu; // --- legacy compatibility for deprecated imports ---

/**
 * @deprecated import these components directly
 */

var MenuContent = {
  ActionMenuTrigger: ActionMenuTrigger
};

export { MenuContent, ActionMenu$1 as default };
